const SCOPE = "diaryListRecords";
const ACTIONS = {
  getSiteRecords: "getSiteRecords",
  getDiariesRecords: "getDiariesRecords",
  getDiariesEditingRecords: "getDiariesEditingRecords",
  getDiariesEditingRecordsCopyModal: "getDiariesEditingRecordsCopyModal",
  getCo2Input: "getCo2Input",
  getMeRecord: "getMeRecord",
  getDiaryDetail: "getDiaryDetail",
  getMetaDataSite: "getMetaDataSite",
};
const MUTATIONS = {
  setSiteRecords: "setSiteRecords",
  setSiteSelected: "setSiteSelected",
  setCalendarDate: "setCalendarDate",
  setDiariesRecords: "setDiariesRecords",
  setDiaryLatest: "setDiaryLatest",
  setStateCopyFunction: "setStateCopyFunction",
  setDiariesEditingRecords: "setDiariesEditingRecords",
  setDiariesEditingRecordsCopyModal: "setDiariesEditingRecordsCopyModal",
  setLoadingDiaryEditing: "setLoadingDiaryEditing",
  setCo2Input: "setCo2Input",
  updateStateCo2Selection:"updateStateCo2Selection",
  updateStateCo2InputElectricity: "updateStateCo2InputElectricity",
  updateStateCo2InputKerosene: "updateStateCo2InputKerosene",
  updateStateCo2InputDiesel: "updateStateCo2InputDiesel",
  updateStateCo2InputHeavyOil: "updateStateCo2InputHeavyOil",
  updateStateCo2InputAlterNativeFuel: "updateStateCo2InputAlterNativeFuel",
  AddAlterNativeFuel: "AddAlterNativeFuel",
  addElectricity: "addElectricity",
  addCementAlterNative: "addCementAlterNative",
  updateStateCo2InputAlterNativeEnergy: "updateStateCo2InputAlterNativeEnergy",
  updateStateCo2InputCementAlternative: "updateStateCo2InputCementAlternative",
  AddAlterNativeEnergy: "AddAlterNativeEnergy",
  updateStateCo2InputOthers: "updateStateCo2InputOthers",
  updateStateCo2InputWater: "updateStateCo2InputWater",
  updateStateCo2SelectionWater: "updateStateCo2SelectionWater",
  setCo2InputOrderUsed: "setCo2InputOrderUsed",
  addAmountCo2Input: "addAmountCo2Input",
  updateCo2InputAmount: "updateCo2InputAmount",
  deleteCo2InputAmount: "deleteCo2InputAmount",
  resetDiaryList: "resetDiaryList",
  resetDiaryListStore: "resetDiaryListStore",
  setName: "setName",
  updateStateCO2InputIsFocus: "updateStateCO2InputIsFocus",
  updateStateCO2InputIsValidate: "updateStateCO2InputIsValidate",
  updateStateCO2InputIsFocusOthers: "updateStateCO2InputIsFocusOthers",
  updateStateCO2InputIsValidateOthers: "updateStateCO2InputIsValidateOthers",
  updateStateCO2InputIsFocusElectricity: "updateStateCO2InputIsFocusElectricity",
  updateStateCO2InputIsValidateElectricity: "updateStateCO2InputIsValidateElectricity",
  updateStateCO2InputIsFocusWater: "updateStateCO2InputIsFocusWater",
  updateStateCO2InputIsValidateWater: "updateStateCO2InputIsValidateWater",
  fixDataCopyDiaryRecord: "fixDataCopyDiaryRecord",
  setMetaDataSite: "setMetaDataSite",
  updateMetaDataSite: "updateMetaDataSite",
};
const GETTERS = {
  getSites: `${SCOPE}/getSites`,
  getTotalSites: `${SCOPE}/getTotalSites`,
  getSiteSelected: `${SCOPE}/getSiteSelected`,
  getCalendarDate: `${SCOPE}/getCalendarDate`,
  getDiariesEditing: `${SCOPE}/getDiariesEditing`,
  getDiariesEditingCopyModal: `${SCOPE}/getDiariesEditingCopyModal`,
  getDiaries: `${SCOPE}/getDiaries`,
  getCo2Input: `${SCOPE}/getCo2Input`,
  getName: `${SCOPE}/getName`,
  getAppRole: `${SCOPE}/getAppRole`,
  getDiaryIdLatest: `${SCOPE}/getDiaryIdLatest`,
  getDiaryLatest: `${SCOPE}/getDiaryLatest`,
  getStateCopyFunction: `${SCOPE}/getStateCopyFunction`,
  getMetaDataSite: `${SCOPE}/getMetaDataSite`,
  getIsLoadingDiaryEditing: `${SCOPE}/getIsLoadingDiaryEditing`,
};
const DISPATCH = {
  getSiteRecords: `${SCOPE}/${ACTIONS.getSiteRecords}`,
  getDiariesRecords: `${SCOPE}/${ACTIONS.getDiariesRecords}`,
  getDiariesEditingRecords: `${SCOPE}/${ACTIONS.getDiariesEditingRecords}`,
  getDiariesEditingRecordsCopyModal: `${SCOPE}/${ACTIONS.getDiariesEditingRecordsCopyModal}`,
  getCo2Input: `${SCOPE}/${ACTIONS.getCo2Input}`,
  getMeRecord: `${SCOPE}/${ACTIONS.getMeRecord}`,
  getDiaryDetail: `${SCOPE}/${ACTIONS.getDiaryDetail}`,
  getMetaDataSite: `${SCOPE}/${ACTIONS.getMetaDataSite}`,
};
const COMMIT = {
  setSiteRecords: `${SCOPE}/${MUTATIONS.setSiteRecords}`,
  setSiteSelected: `${SCOPE}/${MUTATIONS.setSiteSelected}`,
  setCalendarDate: `${SCOPE}/${MUTATIONS.setCalendarDate}`,
  setDiariesRecords: `${SCOPE}/${MUTATIONS.setDiariesRecords}`,
  setDiaryLatest: `${SCOPE}/${MUTATIONS.setDiaryLatest}`,
  setStateCopyFunction: `${SCOPE}/${MUTATIONS.setStateCopyFunction}`,
  setDiariesEditingRecords: `${SCOPE}/${MUTATIONS.setDiariesEditingRecords}`,
  setDiariesEditingRecordsCopyModal: `${SCOPE}/${MUTATIONS.setDiariesEditingRecordsCopyModal}`,
  setCo2Input: `${SCOPE}/${MUTATIONS.setCo2Input}`,
  updateStateCo2Selection: `${SCOPE}/${MUTATIONS.updateStateCo2Selection}`,
  updateStateCo2InputElectricity: `${SCOPE}/${MUTATIONS.updateStateCo2InputElectricity}`,
  updateStateCo2InputKerosene: `${SCOPE}/${MUTATIONS.updateStateCo2InputKerosene}`,
  updateStateCo2InputDiesel: `${SCOPE}/${MUTATIONS.updateStateCo2InputDiesel}`,
  updateStateCo2InputHeavyOil: `${SCOPE}/${MUTATIONS.updateStateCo2InputHeavyOil}`,
  updateStateCo2InputAlterNativeFuel: `${SCOPE}/${MUTATIONS.updateStateCo2InputAlterNativeFuel}`,
  AddAlterNativeFuel: `${SCOPE}/${MUTATIONS.AddAlterNativeFuel}`,
  updateStateCo2InputAlterNativeEnergy: `${SCOPE}/${MUTATIONS.updateStateCo2InputAlterNativeEnergy}`,
  updateStateCo2InputCementAlternative: `${SCOPE}/${MUTATIONS.updateStateCo2InputCementAlternative}`,
  AddAlterNativeEnergy: `${SCOPE}/${MUTATIONS.AddAlterNativeEnergy}`,
  addElectricity: `${SCOPE}/${MUTATIONS.addElectricity}`,
  addCementAlterNative: `${SCOPE}/${MUTATIONS.addCementAlterNative}`,
  updateStateCo2InputOthers: `${SCOPE}/${MUTATIONS.updateStateCo2InputOthers}`,
  updateStateCo2InputWater: `${SCOPE}/${MUTATIONS.updateStateCo2InputWater}`,
  updateStateCo2SelectionWater: `${SCOPE}/${MUTATIONS.updateStateCo2SelectionWater}`,
  setCo2InputOrderUsed: `${SCOPE}/${MUTATIONS.setCo2InputOrderUsed}`,
  addAmountCo2Input: `${SCOPE}/${MUTATIONS.addAmountCo2Input}`,
  updateCo2InputAmount: `${SCOPE}/${MUTATIONS.updateCo2InputAmount}`,
  deleteCo2InputAmount: `${SCOPE}/${MUTATIONS.deleteCo2InputAmount}`,
  resetDiaryList: `${SCOPE}/${MUTATIONS.resetDiaryList}`,
  resetDiaryListStore: `${SCOPE}/${MUTATIONS.resetDiaryListStore}`,
  setName: `${SCOPE}/${MUTATIONS.setName}`,
  updateStateCO2InputIsFocus: `${SCOPE}/${MUTATIONS.updateStateCO2InputIsFocus}`,
  updateStateCO2InputIsValidate: `${SCOPE}/${MUTATIONS.updateStateCO2InputIsValidate}`,
  updateStateCO2InputIsFocusOthers: `${SCOPE}/${MUTATIONS.updateStateCO2InputIsFocusOthers}`,
  updateStateCO2InputIsValidateOthers: `${SCOPE}/${MUTATIONS.updateStateCO2InputIsValidateOthers}`,
  updateStateCO2InputIsFocusElectricity: `${SCOPE}/${MUTATIONS.updateStateCO2InputIsFocusElectricity}`,
  updateStateCO2InputIsValidateElectricity: `${SCOPE}/${MUTATIONS.updateStateCO2InputIsValidateElectricity}`,
  updateStateCO2InputIsValidateWater: `${SCOPE}/${MUTATIONS.updateStateCO2InputIsValidateWater}`,
  fixDataCopyDiaryRecord: `${SCOPE}/${MUTATIONS.fixDataCopyDiaryRecord}`,
  setMetaDataSite: `${SCOPE}/${MUTATIONS.setMetaDataSite}`,
  updateMetaDataSite: `${SCOPE}/${MUTATIONS.updateMetaDataSite}`,
};
export default {
  ACTIONS, MUTATIONS, GETTERS, DISPATCH, COMMIT
};
